import { gql } from "@stadium/services/apollo-client";
export const fetchWidgetStoreDetails = gql`
  query FetchStores($number: String) {
    store(number: $number) {
      feUrl
      id
      number
      parentId
      cloneId
      enabledGlobalCatalog
      isLockerShop: displayWarehouseAddress
      syncedToEs
      cacheKey
      config {
        upcharge
      }
    }
  }
`;
